module.exports = __webpack_public_path__ + "static/sipc-desktop.ca234f38.svg";